<template>
  <!-- Only tenants with a buildings layer (North Africa) have these measurements: hide the card for the rest -->
  <v-container v-if="buildingsData.length !== 0" fluid class="fluid theme_background borderRadius">
    <v-row>
      <v-col cols="12" class="px-0">
        <p class="ml-2 right_panel_title">
          <v-avatar color="rgb(var(--v-theme-dark-color))" size="small" class="pa-0 mr-2">
            <v-icon color="rgb(var(--v-theme-lighten))" large>mdi-home</v-icon>
          </v-avatar>
          {{ $t('views.risk.buildings') }}
        </p>
      </v-col>
    </v-row>
    <v-row v-for="(entry, index) in buildingsData" :key="entry.id ?? index" class="panelDataRow">
      <square-chip
        :title="$t(`domain.enums.buildingsType.${entry.measurementType.name}`)"
        :color="entry.measurementType.color ?? ''"
        :subtitle="$t('domain.fields.buffer')"></square-chip>
      <square-chip :title="entry.value" color="rgb(var(--v-theme-surface))" :subtitle="$t('views.risk.buildings')"></square-chip>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { storeToRefs } from 'pinia'

import SquareChip from '@/components/Cards/SquareChip.vue'
import IncidentStore from '@/stores/incidentStore'

const { buildings } = storeToRefs(IncidentStore())

const buildingsData = computed(() => buildings.value ?? [])
</script>

<style></style>
